import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import randomstring from 'uuid/v4';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import * as actions from '../../../../actions/api.reports.search.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import Download from './Download';

import Snackbar from '../../../labels/Snackbar';

class ListValues extends React.Component {
    state = {
        error: undefined,
        data:
            this.props.report_search_is_values && this.props.report_search_is_values.values
                ? this.props.report_search_is_values.values
                : [],
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            data:
                nextProps.report_search_is_values && nextProps.report_search_is_values.values
                    ? nextProps.report_search_is_values.values
                    : [],
        });
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { error, data } = this.state;
        const { intl, report_search_is_values } = this.props;

        return (
            <div className={'flex_full_column height100 padding_borders showbar overflow_x_scroll'}>
                <div className={'flex_full_row overflow_y_scroll '} onScroll={this.handleScroll}>
                    <Table className="table_search table">
                        <TableHead className="table-header">
                            <TableRow>
                                <TableCell className="table-header_th">
                                    {intl.formatMessage({ id: 'date' })}
                                </TableCell>
                                <TableCell className="table-header_th">
                                    {intl.formatMessage({ id: 'filled' })}
                                </TableCell>
                                <TableCell className="table-header_th">
                                    {intl.formatMessage({ id: 'instance' })}
                                </TableCell>
                                <TableCell className="table-header_th">
                                    {intl.formatMessage({ id: 'user' })}
                                </TableCell>
                                <TableCell className="table-header_th">
                                    {intl.formatMessage({ id: 'local' })}
                                </TableCell>
                                <TableCell className="table-header_th">
                                    {intl.formatMessage({ id: 'value' })}
                                </TableCell>
                                <TableCell className="table-header_th" />
                            </TableRow>
                        </TableHead>
                        <TableBody className="table_search_tbody">
                            {data.map((row) => (
                                <TableRow key={randomstring()}>
                                    <TableCell component="th" scope="row">
                                        {row.creado}
                                    </TableCell>
                                    <TableCell scope="row">
                                        {row.cierretarea}
                                    </TableCell>
                                    <TableCell align="right">{row.instancia}</TableCell>
                                    <TableCell align="right">{row.usuario}</TableCell>
                                    <TableCell align="right">{row.nlocal}</TableCell>
                                    <TableCell align="right" className="text_wrap">
                                        {row.valor === true
                                            ? intl.formatMessage({ id: 'type_label_boolean_yes' })
                                            : row.valor === false
                                            ? intl.formatMessage({
                                                  id: 'type_label_boolean_no',
                                              })
                                            : row.valor}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.vencido && <div className="dot18 bg_lipstick" />}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
                <Download info={data} parameters={[report_search_is_values]} />
                {error && (
                    <Snackbar
                        open={true}
                        variant="error"
                        text={error}
                        onClose={this.handleCloseError.bind(this)}
                    />
                )}
            </div>
        );
    }
}

ListValues.propTypes = {
    intl: intlShape.isRequired,
    report_search_is_values: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        report_search_is_values: state.report_search_is_values,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(ListValues));



// WEBPACK FOOTER //
// ./src/components/complex/reports/search/List.js